import React from "react";

const FilterIcon= () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      data-name="Layer 1"
      viewBox="0 0 24 24"
    >
      <path d="M5 4.146V0H3v4.146C1.556 4.577.5 5.918.5 7.5s1.056 2.923 2.5 3.354V24h2V10.854c1.444-.431 2.5-1.772 2.5-3.354S6.444 4.577 5 4.146zM4 9c-.827 0-1.5-.673-1.5-1.5S3.173 6 4 6s1.5.673 1.5 1.5S4.827 9 4 9zm9 4.146V0h-2v13.146c-1.444.431-2.5 1.772-2.5 3.354s1.056 2.923 2.5 3.354V24h2v-4.146c1.444-.431 2.5-1.772 2.5-3.354s-1.056-2.923-2.5-3.354zM12 18c-.827 0-1.5-.673-1.5-1.5S11.173 15 12 15s1.5.673 1.5 1.5S12.827 18 12 18zM23.5 7.5A3.506 3.506 0 0021 4.146V0h-2v4.146c-1.444.431-2.5 1.772-2.5 3.354s1.056 2.923 2.5 3.354V24h2V10.854A3.506 3.506 0 0023.5 7.5zM20 9c-.827 0-1.5-.673-1.5-1.5S19.173 6 20 6s1.5.673 1.5 1.5S20.827 9 20 9z"></path>
    </svg>
  );
}

export {FilterIcon};